import React from 'react';
import PropTypes from 'prop-types';

import queryString from 'query-string';
import history from 'shared_history';

const withSchoolYear = (defaultSchoolYear = () => null) => (WrappedComponent) => {
  const SchoolYearedComponent = (props) => {
    const { location } = props;
    const { search } = location;
    const schoolYearId = queryString.parse(search).school_year_id || defaultSchoolYear(props).id;

    const onSchoolYearChange = (year) => {
      // noinspection JSUnusedLocalSymbols
      const { school_year_id, page, ...query } = queryString.parse(search); // eslint-disable-line
      query.school_year_id = year;

      history.push({
        ...location,
        search: `?${queryString.stringify(query)}`
      });
    };

    return <WrappedComponent {...props} schoolYearId={schoolYearId} onSchoolYearChange={onSchoolYearChange} />;
  };

  SchoolYearedComponent.propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string
    }).isRequired
  };

  return SchoolYearedComponent;
};

withSchoolYear.propTypes = {
  WrappedComponent: PropTypes.element
};

/**
 * Gets the default school year to use in a billing context.
 *
 * @param customer
 * @returns {*}
 */
const defaultBillingSchoolYear = ({ customer }) => {
  // If the current enrollment year is enabled for billing, use that, else use the end year of billing, if none of those, default to the billing start year
  if (customer.current_enrollment_year && customer.current_enrollment_year.billing_enabled) {
    return customer.current_enrollment_year;
  } else if(customer && customer.billing_end_year){
    return customer.billing_end_year;
  } else {
    return customer.billing_start_year;
  }};

export { defaultBillingSchoolYear };
export default withSchoolYear;
